/* corex-textil-editor-export.js · Archivos de producción del personalizador de camisetas (los usa el pedido al añadir
   al carrito): PNG de cada impresión por talla y vista previa JPG por color. attach(root, ed) recibe del editor:
   prints(vista), sizeIndex(talla), refSize(), getImage, loadColor(color), withPaint(color, fn), views, frameFor,
   drawBase, drawWarped, renderArea, drawSleevesOnFront. */
(function () {
  'use strict';

  var G = window.CorexTextilGeo, M = window.CorexTextilModel;
  var SIM_BAND = 0.09;      /* alto de la franja del aviso, en fracción del ancho de un panel */
  var SIM_FONT = 0.026;     /* tamaño de letra máximo, en fracción del ancho de un panel; baja si no cabe */

  function simText(root) { var el = root.querySelector('[data-cte-sim]'); return el ? el.textContent.trim() : ''; }
  /* Franja inferior: fondo gris muy claro y el aviso centrado en una línea (letra reducida hasta que quepa). */
  function simBand(c, text, x, y, w, h, pad) {
    if (!text) return;
    c.fillStyle = '#F4F2EF';
    c.fillRect(x, y, w, h);
    var size = Math.round(h / SIM_BAND * SIM_FONT);
    c.font = '500 ' + size + 'px sans-serif';
    while (size > 8 && c.measureText(text).width > w - 2 * pad) { size--; c.font = '500 ' + size + 'px sans-serif'; }
    c.fillStyle = '#7A746C';
    c.textAlign = 'center';
    c.textBaseline = 'middle';
    c.fillText(text, x + w / 2, y + h / 2);
  }

  function attach(root, ed) {
    /* PNG de una impresión en una talla: recortado a la caja real del diseño (capas visibles), a su tamaño real en esa
       talla y a dpi. Sin prenda ni guías; sin espejo. El ancho es exactamente el de la tabla por talla (cm enteros:
       3,5 % por talla desde la de referencia y redondeado, corex-textil-editor-model.js) y el alto, en proporción. */
    root.cteRenderPrintFile = function (viewId, printId, talla, dpi) {
      var p = ed.prints(viewId).filter(function (x) { return x.id === printId; })[0], b = p && G.designBounds(p.layers);
      if (!b) throw new Error('La impresión no tiene diseño.');
      var row = ed.printRow(viewId, printId, talla);
      var f = row && row.escala ? row.escala : M.scaleFactor(ed.sizeIndex(talla), ed.sizeIndex(ed.refSize()));
      var cv = document.createElement('canvas');
      cv.width = Math.max(1, Math.round((row && row.ancho ? row.ancho : b.w * f) * dpi / 2.54));
      var k = cv.width / b.w;
      cv.height = Math.max(1, Math.round(b.h * k));
      f = k * 2.54 / dpi;
      var c = cv.getContext('2d');
      c.setTransform(k, 0, 0, k, -(b.cx - b.w / 2) * k, -(b.cy - b.h / 2) * k);
      G.drawLayers(c, p.layers, ed.getImage);
      return { canvas: cv, wCm: b.w * f, hCm: b.h * f };
    };
    /* Vista previa de un color, como la ve el cliente: delante (con las mangas) y detrás, con la foto real de ese color,
       y abajo una franja discreta con el aviso de imagen simulada (el texto del aviso de la página, [data-cte-sim]).
       Devuelve un lienzo con fondo blanco (para JPG). */
    /* Delante (con las mangas) y detrás de un color con la foto real y el diseño, sobre fondo transparente, cada uno de
       panelW px de ancho. Lo usan la vista previa JPG del carrito y la descarga para redes (corex-textil-redes.js). */
    root.cteRenderPanels = function (color, panelW) {
      return ed.loadColor(color).then(function () {
        return ed.withPaint(color, function () {
          return ['front', 'back'].map(function (kind) {
            /* delante: todas las vistas de delante (cremallera: los dos pechos sobre la misma foto) */
            var views = ed.views.filter(function (v) { return v.kind === kind; }), viewId = views[0].id, frame = ed.frameFor(viewId, ed.refSize());
            var w = panelW, h = Math.round(w * frame.view.h / frame.view.w), s = w / frame.view.w;
            var cv = document.createElement('canvas'), pc = cv.getContext('2d'), tf = [s, 0, 0, s, -frame.view.x * s, -frame.view.y * s];
            cv.width = w; cv.height = h;
            pc.setTransform.apply(pc, tf);
            ed.drawBase(pc, frame, kind);
            views.forEach(function (v) {
              ed.prints(v.id).forEach(function (p) { ed.drawWarped(pc, cv, p.layers, ed.renderArea(v.id, p), frame, kind, tf, frame.pxPerCm * s * 1.5, 'jpg-' + p.id); });
            });
            if (kind === 'front') ed.drawSleevesOnFront(pc, cv, frame, tf);
            return cv;
          });
        });
      });
    };
    /* Vista previa de un color, como la ve el cliente: delante y detrás y abajo una franja discreta con el aviso de
       imagen simulada (el texto del aviso de la página, [data-cte-sim]). Devuelve un lienzo con fondo blanco (para JPG). */
    root.cteRenderColorPreview = function (color, panelW) {
      return root.cteRenderPanels(color, panelW).then(function (panels) {
        var gap = Math.round(panelW * 0.06), band = Math.round(panelW * SIM_BAND), out = document.createElement('canvas');
        var panelsH = Math.max(panels[0].height, panels[1].height);
        out.width = panels[0].width + panels[1].width + gap * 3;
        out.height = panelsH + gap * 2 + band;
        var oc = out.getContext('2d');
        oc.fillStyle = '#FFFFFF';
        oc.fillRect(0, 0, out.width, out.height);
        oc.drawImage(panels[0], gap, gap);
        oc.drawImage(panels[1], gap * 2 + panels[0].width, gap);
        simBand(oc, simText(root), 0, panelsH + gap * 2, out.width, band, gap);
        return out;
      });
    };
  }

  window.CorexTextilExport = { attach: attach };
})();
